import {DialogService} from "../common/Dialog";
import {getPermissions} from "./rbac-utils";
import * as SomlUtils from "./soml-utils";

export function getPermissionMessage(message: string, schemaId: string) {
  return `${message}${schemaId}`;
}

export function noPermissionMessage(message: string) {
  return (schemaId: string) => {
    return getPermissionMessage(message, schemaId);
  }
}

/**
 * Checks if current user has write permissions over schema with provided id.
 * @param {string} schemaId the schema id
 * @param rejectionMessage partially applied function which must return a string message
 * @return {boolean} <code>false</code> if writing is forbidden and true otherwise.
 */
export function canCreateSchemaById(schemaId: string, rejectionMessage: any): boolean {
  const permissions = getPermissions(schemaId);
  const canCreate = permissions.canWrite;
  if (!canCreate) {
    DialogService.warning({
      message: rejectionMessage(schemaId)
    });
    return false;
  }
  return true;
}

/**
 * Checks if current user has write permissions over the provided schema.
 * @param {string} schema the schema
 * @param rejectionMessage partially applied function which must return a string message
 * @return {boolean} <code>false</code> if writing is forbidden and true otherwise.
 */
export function canCreateSchema(schema: string, rejectionMessage: any): boolean {
  const parsedSchema = SomlUtils.parseSchemaYaml(schema);
  const canCreate = parsedSchema.permissions.canWrite;
  if (!canCreate) {
    DialogService.warning({
      message: rejectionMessage(parsedSchema.id)
    });
    return false;
  }
  return true;
}
